import React, { Component } from 'react'

class Banner extends Component {
  render() {
    return (
      <div className="inner-banner">
        <div className="opacity">
          <div className="container">
            <h2>Our Blog</h2>
            <ul>
              <li><a href="/" className="tran3s">Home</a></li>
              <li>/</li>
              <li>Blog</li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

export default Banner